import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { OutcomesFormProps } from '~pages/Dialler/ConnectDialler/VoiceView/OutcomeCapture';

const OutcomesForm = ({ formSubmitting }: OutcomesFormProps) => {
  const {
    control,
    getValues,
    formState: { errors },
  } = useFormContext();
  const cidn = getValues().cidn;
  const sales_id = getValues().sales_id;

  return (
    <>
      <Grid item xs={12}>
        <Controller
          name='brand_code'
          defaultValue={'EJCM'}
          control={control}
          render={({ field }) => (
            <TextField
              {...field}
              fullWidth
              variant='outlined'
              id='brand_code'
              label='Dealer Code'
              disabled={true}
              error={Boolean(errors.brand_code)}
              helperText={errors.brand_code?.message as string | undefined}
            />
          )}
        />
      </Grid>

      <Grid item xs={12}>
        <Controller
          name='customer_full_name'
          control={control}
          defaultValue={''}
          render={({ field }) => (
            <TextField
              {...field}
              fullWidth
              variant='outlined'
              id='customer_full_name'
              label='Customer Full Name (first and last name)'
              disabled={formSubmitting}
              error={Boolean(errors.customer_full_name)}
              helperText={errors.customer_full_name?.message as string | undefined}
            />
          )}
        />
      </Grid>

      {cidn && (
        <Grid item xs={12}>
          <Controller
            name='cidn'
            control={control}
            defaultValue={''}
            render={({ field }) => (
              <TextField
                {...field}
                fullWidth
                variant='outlined'
                id='cidn'
                label='CIDN (Telstra Customer ID)'
                disabled={formSubmitting}
                error={Boolean(errors.cidn)}
                helperText={errors.cidn?.message as string | undefined}
              />
            )}
          />
        </Grid>
      )}

      {sales_id && (
        <Grid item xs={12}>
          <Controller
            name='sales_id'
            control={control}
            defaultValue={''}
            render={({ field }) => (
              <TextField
                {...field}
                fullWidth
                variant='outlined'
                id='sales_id'
                label='Sales ID'
                disabled={formSubmitting}
                error={Boolean(errors.sales_id)}
                helperText={errors.sales_id?.message as string | undefined}
              />
            )}
          />
        </Grid>
      )}
    </>
  );
};

export default OutcomesForm;
